import type { Middleware } from 'openapi-fetch';

export class ProjectIpRestrictedError extends Error {
  readonly status = 403;

  constructor() {
    super('許可されたIPアドレスではありません。');
    this.name = 'ProjectIpRestrictedError';
  }
}

export const isProjectIpRestrictedError = (error: unknown): error is ProjectIpRestrictedError =>
  error instanceof Error && error.name === 'ProjectIpRestrictedError' && 'status' in error && error.status === 403;

export const projectIpRestrictionMiddleware: Middleware = {
  async onResponse({ response }) {
    if (response.status !== 403) return;
    const body: unknown = await response
      .clone()
      .json()
      .catch(() => undefined);
    if (
      typeof body === 'object' &&
      body !== null &&
      'errorCode' in body &&
      typeof body.errorCode === 'object' &&
      body.errorCode !== null &&
      'id' in body.errorCode &&
      body.errorCode.id === 'auth.project.ip.forbidden'
    ) {
      throw new ProjectIpRestrictedError();
    }
  },
};
